import { render, staticRenderFns } from "./TheHasGaraOnline.vue?vue&type=template&id=5c88a281"
import script from "./TheHasGaraOnline.vue?vue&type=script&lang=ts"
export * from "./TheHasGaraOnline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSearchFiltersTheSwitch: require('/usr/src/nuxt-app/components/core/search/filters/TheSwitch.vue').default})
